import { EFurnitureType } from 'shared/types/filters/advanced/furnitureType';

export const mapFurnitureLabel = {
  [EFurnitureType.WithFurniture]: 'С мебелью',
  [EFurnitureType.WithoutFurniture]: 'Без мебели',
};
